/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { serviceCategoryIdGet } from '../fn/service-category/service-category-id-get';
import { ServiceCategoryIdGet$Params } from '../fn/service-category/service-category-id-get';
import { ServiceCategoryModel } from '../models/service-category-model';
import { ServiceCategoryModelSearchResultModel } from '../models/service-category-model-search-result-model';
import { serviceCategoryPost } from '../fn/service-category/service-category-post';
import { ServiceCategoryPost$Params } from '../fn/service-category/service-category-post';
import { serviceCategorySearchServiceCategoryAsyncPost } from '../fn/service-category/service-category-search-service-category-async-post';
import { ServiceCategorySearchServiceCategoryAsyncPost$Params } from '../fn/service-category/service-category-search-service-category-async-post';

@Injectable({ providedIn: 'root' })
export class MDIServiceCategoryService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `serviceCategorySearchServiceCategoryAsyncPost()` */
  static readonly ServiceCategorySearchServiceCategoryAsyncPostPath = '/ServiceCategory/SearchServiceCategoryAsync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceCategorySearchServiceCategoryAsyncPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceCategorySearchServiceCategoryAsyncPost$Response(params?: ServiceCategorySearchServiceCategoryAsyncPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceCategoryModelSearchResultModel>> {
    return serviceCategorySearchServiceCategoryAsyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceCategorySearchServiceCategoryAsyncPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceCategorySearchServiceCategoryAsyncPost(params?: ServiceCategorySearchServiceCategoryAsyncPost$Params, context?: HttpContext): Observable<ServiceCategoryModelSearchResultModel> {
    return this.serviceCategorySearchServiceCategoryAsyncPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ServiceCategoryModelSearchResultModel>): ServiceCategoryModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `serviceCategoryIdGet()` */
  static readonly ServiceCategoryIdGetPath = '/ServiceCategory/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceCategoryIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceCategoryIdGet$Response(params: ServiceCategoryIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceCategoryModel>> {
    return serviceCategoryIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceCategoryIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceCategoryIdGet(params: ServiceCategoryIdGet$Params, context?: HttpContext): Observable<ServiceCategoryModel> {
    return this.serviceCategoryIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ServiceCategoryModel>): ServiceCategoryModel => r.body)
    );
  }

  /** Path part for operation `serviceCategoryPost()` */
  static readonly ServiceCategoryPostPath = '/ServiceCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceCategoryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceCategoryPost$Response(params?: ServiceCategoryPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return serviceCategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceCategoryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceCategoryPost(params?: ServiceCategoryPost$Params, context?: HttpContext): Observable<string> {
    return this.serviceCategoryPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
